// extracted by mini-css-extract-plugin
module.exports = {"title":"location-modal_title__18VCf","icon":"location-modal_icon__2NNtw","description":"location-modal_description__mbOBo","container":"location-modal_container__bDY8I"};